// 解决警告配置在vite.config.js中，
// todo 不要在这里直接修改地址为'vue-i18n/dist/vue-i18n.cjs.js'，解决不了问题，目前在配置文件配置alias消除
import { createI18n } from 'vue-i18n'
import store from '@/store/index.js'
/*
 * 默认只引入 element-plus 的中英文语言包
 * 其他语言包请自行在此 import,并添加到 assignLocale 内
 * 动态 import 只支持相对路径，所以无法按需 import element-plus 的语言包
 * 但i18n的 messages 内是按需载入的
 */

// todo vite 动态导入有两种方式
//
// import.meta.glob: 通过动态导入默认懒加载，通过遍历加 then 方法可拿到对应的模块文件详情信息
// import.meta.globEager: 直接引入所有的模块, 即静态 import; 这个打包部署会报错

import vantZhCnLocale from 'vant/es/locale/lang/zh-CN'
import vantEnLocale from 'vant/es/locale/lang/en-US'
import emitter from '@/utils/event_bus.js'

// 加载逻辑--异步
// todo async await不是很会用，这里不加获取不到数据
const loadLang = async () => {
  const lang = store.getters['appStore/getLangConfig']()
  console.info('locale', lang)
  const globs_cn = await import('./globs_zh_cn.js')
  const globs_en = await import('./globs_en.js')

  // 列出对应 语言分类下的所有js文件
  const modules_cn = import.meta.glob('./page/zh_cn/**/*.js')
  const modules_en = import.meta.glob('./page/en/**/*.js')
  // todo 这样就可以取到js文件的default内容，一定要加await，要不然取不到，另外，定义的js文件中，一定要写export default{}
  /*
   * 0、加载页面语言包 import.meta.globEager 的路径不能使用变量
   * 1、vue3 setup 内只能使用 useI18n({messages:{}}) 来动态载入当前页面单独的语言包，不方便使用
   * 2、直接载入所有 /@/lang/pages/语言/*.ts 文件，若某页面有特别大量的语言配置，可在其他位置单独建立语言包文件，并在对应页面加载语言包
   */
  const msg_cn = await getLangFileMessage(modules_cn, 'zh_cn')
  const msg_en = await getLangFileMessage(modules_en, 'en')
  // assignLocale[locale].push(msg)
  const messages = {
    'zh-cn': {
      ...vantZhCnLocale,
      ...globs_cn.default,
      app: {...msg_cn}
    },
    en: {
      ...vantEnLocale,
      ...globs_en.default,
      app: {...msg_en}
    }
  }
  // 合并语言包(含element-puls、页面语言包)
  // Object.assign(messages[locale], assignLocale[locale])
  console.debug('i18n', messages)
  const i18n = createI18n({
    // 语言标识
    locale: lang,
    legacy: false, // 组合式api
    globalInjection: true, // 挂载$t,$d等到全局
    // 找不到从这里去取
    fallbackLocale: store.getters['appStore/getLangConfig']('cb'),
    messages
  })
  return i18n
}

/**
 * 获取对应js文件中的内容
 * @param mList
 * @param locale
 * @returns {Promise<{}>}
 */
const getLangFileMessage = async (mList, locale) => {
  let msg = {}
  locale = '/' + locale
  for (const path in mList) {
    // 获取js
    const cxt = await mList[path]()
    // 获取js文件名，不包后缀名，作为多文件下的key
    const pathName = path.slice(path.lastIndexOf(locale) + (locale.length + 1), path.lastIndexOf('.'))
    if (pathName.indexOf('/') > 0) {
      msg = handleMsgList(msg, cxt.default, pathName)
    } else {
      msg[pathName] = cxt.default
    }
  }
  return msg
}

/**
 * 嵌套层文件处理例如：auth0/auth1/auth2/xxx.js
 * @param msg
 * @param mList
 * @param pathName
 * @returns {*}
 */
const handleMsgList = (msg, mList, pathName) => {
  const pathNameTmp = pathName.split('/')
  let obj = {}
  for (let i = pathNameTmp.length - 1; i >= 0; i--) {
    if (i === pathNameTmp.length - 1) {
      obj = {
        [pathNameTmp[i]]: mList
      }
    } else {
      obj = {
        [pathNameTmp[i]]: obj
      }
    }
  }
  return mergeMsg(msg, obj)
}

const mergeMsg = (msg, obj) => {
  for (const key in obj) {
    if (typeof msg[key] === 'undefined') {
      msg[key] = obj[key]
    } else if (typeof msg[key] === 'object') {
      msg[key] = mergeMsg(msg[key], obj[key])
    }
  }
  return msg
}

const editDefaultLang = (lang) => {
  store.dispatch('appStore/setLang', lang)
  emitter.emit('i18nChange', lang)
}

export {
  loadLang,
  editDefaultLang
}
